"use strict";

exports.__esModule = true;
exports.renderExternalRow = renderExternalRow;
var _react = _interopRequireDefault(require("react"));
var _HasAccess = require("../../../Auth/Access/HasAccess");
var _styledComponents = require("./styledComponents");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function renderExternalRow(props) {
  var thumbnailSize = props.thumbnailSize,
    item = props.item;
  var Thumbnail = item.thumbnail;
  return /*#__PURE__*/_react["default"].createElement(_HasAccess.HasAccess, {
    key: item.id,
    permission: item.permission
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.ReportListItem, {
    key: item.id,
    "data-testid": "ReportListItem",
    to: item.path
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.ReportListItemThumbnailWrapper, {
    width: thumbnailSize,
    height: thumbnailSize
  }, /*#__PURE__*/_react["default"].createElement(Thumbnail, {
    width: thumbnailSize,
    height: thumbnailSize
  })), /*#__PURE__*/_react["default"].createElement(_styledComponents.ReportListItemLabel, {
    title: item.name,
    "data-testid": "ReportListItem.label"
  }, item.name)));
}